export enum TransactionType {
  PaymentSucceeded = 1,
  PaymentRefunded = 2,
  PaymentFailed = 3,
}
